import React, { Component } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";

import { deselectAll } from "../../actions/select_actions";

import {
  deleteOrderById,
  ordersByShipmentId,
  allOrders
} from "../../queries/orders";
import { deleteCarrierById, allCarriers } from "../../queries/carriers";
import { deleteShipmentById, allShipments } from "../../queries/shipments";
import { deleteStorageById, allStorages } from "../../queries/files";
import { deleteRelationById, allRelations } from "../../queries/relations";
import {
  deleteContactById,
  contactsByRelationId
} from "../../queries/contacts";

import { Mutation } from "react-apollo";
import { toast } from "react-toastify";

import {
  Dialog,
  DialogType,
  DialogFooter
} from "office-ui-fabric-react/lib/Dialog";
import {
  IconButton,
  CommandBarButton,
  PrimaryButton,
  DefaultButton
} from "office-ui-fabric-react/lib/Button";

class ConfirmDeleteDialog extends Component {
  constructor() {
    super();
    this.state = {
      hideDialog: true
    };
  }

  _showDialog = () => {
    this.setState({ hideDialog: false });
  };

  _closeDialog = () => {
    this.setState({ hideDialog: true });
  };

  _selectQueryToRefetch = () => {
    switch (this.props.model) {
      case "shipment":
        return [
          {
            query: allShipments,
            variables: { archived: false }
          }
        ];
      case "order":
        return [
          {
            query: ordersByShipmentId,
            variables: { id: this.props.selectedShipmentId }
          },
          {
            query: allOrders,
            variables: {
              notPlanned: true
            }
          },
          {
            query: COUNT_ORDERS
          }
        ];
      case "carrier":
        return;
        [
          {
            query: allCarriers
          }
        ];
      case "storage":
        return;
        [
          {
            query: allStorages
          }
        ];
        return;
      case "relation":
        return [
          {
            query: allRelations
          }
        ];
      case "contact":
        return [
          {
            query: contactsByRelationId,
            variables: { id: this.props.selectedRelationId }
          }
        ];
      default:
        return null;
    }
  };

  _selectMutation = () => {
    switch (this.props.model) {
      case "shipment":
        return deleteShipmentById;
      case "order":
        return deleteOrderById;
      case "carrier":
        return deleteCarrierById;
      case "storage":
        return deleteStorageById;
      case "relation":
        return deleteRelationById;
      case "contact":
        return deleteContactById;
      default:
        return null;
    }
  };
  render() {
    let { items, model, asIcon } = this.props;

    return (
      <div>
        {asIcon ? (
          <IconButton
            onClick={this._showDialog}
            iconProps={{ iconName: "Delete" }}
            title="Delete file"
          />
        ) : (
          <CommandBarButton
            styles={{ root: { padding: "10px" } }}
            iconProps={{ iconName: "Delete" }}
            title={`Delete ${model}`}
            disabled={items.length > 0 ? false : true}
            onClick={this._showDialog}
          />
        )}

        <Dialog
          hidden={this.state.hideDialog}
          onDismiss={this._closeDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: `Delete ${
              items && items.length !== 0 ? items.length : ""
            } ${model}`,
            subText: "Are you sure ?"
          }}
          modalProps={{
            isBlocking: true
          }}
        >
          <Mutation mutation={this._selectMutation()}>
            {(deleteItems, { data }) => (
              <DialogFooter>
                <PrimaryButton
                  text="Delete"
                  onClick={e => {
                    items.map(item => {
                      deleteItems({
                        refetchQueries: this._selectQueryToRefetch(),
                        variables: { id: item.id }
                      })
                        .then(response => {
                          //TODO deselect all
                          toast.success(`Deleted !`);
                        })
                        .catch(err => {
                          toast.error(`${err}`);
                        });
                    });
                    this.props.deselectAll();
                    this._closeDialog();
                  }}
                />
                <DefaultButton onClick={this._closeDialog} text="Cancel" />
              </DialogFooter>
            )}
          </Mutation>
        </Dialog>
      </div>
    );
  }
}

const COUNT_ORDERS = gql`
  query countOrders {
    countOrders
  }
`;

const mapStateToProps = state => {
  return {
    selectedShipmentId: state.selected.shipment.id,
    selectedRelationId: state.selected.relation.id
  };
};

export default connect(mapStateToProps, { deselectAll: deselectAll })(
  ConfirmDeleteDialog
);



// WEBPACK FOOTER //
// ./src/common/Forms/_ConfirmDeleteDialog.js